module.exports = __webpack_public_path__ + "assets/img/touxiang.c4c06962.png";